export enum MAP {
  MAP_2D = '2d map',
  MAP_3D = '3d map',
  MAP_BIRD_VIEW = 'bird view',
}

export enum MAP_2D_MODE {
  SATELLITE = 'SATELLITE',
  STANDARD = 'STANDARD',
  STREET_NAMES = 'STREET_NAMES',
}
